import http from '@/core/http'

const state = {
  id: null,
  items: [],
  itemsTransactions: [],
  images: [],
  transacaoStatus: [],
  totalItems: 0
}

const actions = {
  getItemsDepositos: async ({ commit }, payload) => {
    const result = await http.get('despacho-pendente/depositos', { params: payload })
    commit('ADD_ITENS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result)
  },

  getItemsResgates: async ({ commit }, payload) => {
    const result = await http.get('despacho-pendente/resgates', { params: payload })
    commit('ADD_ITENS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result)
  },
  getItemsVendaCredito: async ({ commit }, payload) => {
    const result = await http.get('despacho-pendente/venda-credito', { params: payload })
    commit('ADD_ITENS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result)
  },
  getItemsPreCaixa: async ({ commit }, payload) => {
    const result = await http.get('despacho-pendente/pre-caixa', { params: payload })
    commit('ADD_ITENS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result)
  },
  getItemsZeraSaldo: async ({ commit }, payload) => {
    const result = await http.get('despacho-pendente/zera-saldo', { params: payload })
    commit('ADD_ITENS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result)
  },
  getItemsVendaJogo: async ({ commit }, payload) => {
    const result = await http.get('despacho-pendente/venda-jogo', { params: payload })
    commit('ADD_ITENS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result)
  },

  baixarDeposito: async ({ commit }, payload) => {
    const result = await http.put('despacho-pendente/depositos', payload)
    commit('ADD_ITEMS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  baixarResgate: async ({ commit }, payload) => {
    const result = await http.put('despacho-pendente/resgates', payload)
    commit('ADD_ITEMS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  baixarVendaCredito: async ({ commit }, payload) => {
    const result = await http.put('despacho-pendente/venda-credito', payload)
    commit('ADD_ITEMS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  baixarPreCaixa: async ({ commit }, payload) => {
    const result = await http.put('despacho-pendente/pre-caixa', payload)
    commit('ADD_ITEMS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  baixarZeraSaldo: async ({ commit }, payload) => {
    const result = await http.put('despacho-pendente/zera-saldo', payload)
    commit('ADD_ITEMS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  baixarVendaJogo: async ({ commit }, payload) => {
    const result = await http.put('despacho-pendente/venda-jogo', payload)
    commit('ADD_ITEMS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  aprovarResgate: async ({ commit }, payload) => {
    const result = await http.post('despacho-pendente/resgates', payload)
    commit('ADD_ITEMS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  recusarResgate: async ({ commit }, payload) => {
    const result = await http.delete('despacho-pendente/resgates/recusar', { params: payload })
    commit('ADD_ITEMS', result.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  processarItensSelecionadosDepositos: async (_, payload) => {
    const result = await http.put('despacho-pendente/depositos', payload)
    return Promise.resolve(result.data)
  },

  processarItensSelecionadosResgates: async (_, payload) => {
    const result = await http.put('despacho-pendente/resgates', payload)
    return Promise.resolve(result.data)
  },

  cancelarDeposito: async ({ commit }, payload) => {
    const result = await http.delete('despacho-pendente/depositos', { params: payload })
    commit('ADD_ITEMS_TRANSACTION', result.data.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },

  cancelarResgate: async ({ commit }, payload) => {
    const result = await http.delete('despacho-pendente/resgates', { params: payload })
    commit('ADD_ITEMS_TRANSACTION', result.data.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },
  cancelarVendaJogo: async ({ commit }, payload) => {
    const result = await http.delete('despacho-pendente/venda-jogo', { params: payload })
    commit('ADD_ITEMS_TRANSACTION', result.data.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },
  cancelarZeraSaldo: async ({ commit }, payload) => {
    const result = await http.delete('despacho-pendente/zera-saldo', { params: payload })
    commit('ADD_ITEMS_TRANSACTION', result.data.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },
  cancelarPreCaixa: async ({ commit }, payload) => {
    const result = await http.delete('despacho-pendente/pre-caixa', { params: payload })
    commit('ADD_ITEMS_TRANSACTION', result.data.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },
  cancelarVendaCredito: async ({ commit }, payload) => {
    const result = await http.delete('despacho-pendente/venda-credito', { params: payload })
    commit('ADD_ITEMS_TRANSACTION', result.data.data)
    // if (!result.data.affected) throw new Error(result)
    return Promise.resolve(result.data)
  },
}

const mutations = {
  'ADD_ITENS' (state, payload) {
    state.items = payload.data
    state.totalItems = payload.totalItens
  },

  'CLEAR_ITENS' (state) {
    state.items = []
  },
 
}

const getters = {
  items: state => state.items,
  listaItens: state => state.items,
  totalItens: state => state.totalItems
}

export default { namespaced: true, state, actions, mutations, getters }